import {Injectable} from '@angular/core';

import {AbstractContainer} from '../util/abstract-container.service';

/**
 * Service that contains an application's subheader
 */
@Injectable({providedIn: 'root'})
export class ApplicationSubheaderContainer extends AbstractContainer {}
